import React, { useState, useEffect } from 'react';
import styles from './EtcModels.module.css';
import { useTranslation } from 'react-i18next';
// 🚨 사용하지 않는 plus, minus 아이콘 임포트를 제거했습니다.
import downTriangleIcon from "../../img/icon/DownTriangleIcon.png";
import sideTriangleIcon from "../../img/icon/SideTriangleIcon.png";

import CancerName from "./CancerName";

// props 대신 구조 분해 할당을 사용하여 코드를 직관적으로 만듭니다.
function EtcModels({ search, num, returnFalse }) {
    const { t } = useTranslation();
    const [visibleFirst, setVisibleFirst] = useState(false);
    const [cancerDatas, setData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = cancerDatas.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageClick = (pageNumber) => setCurrentPage(pageNumber);

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(cancerDatas.length / itemsPerPage); i++) {
        pageNumbers.push(i);
    }

    // 삼항 연산자를 활용한 간결한 체크 로직
    const checkZero = (n) => (n === 0 || !n ? '' : `(${n})`);

    useEffect(() => {
        const reqOption = {
            method: "POST", // 대문자 컨벤션 유지
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify({
                // 이전 리뷰들과 일관성을 맞추기 위해 param 대신 search 키워드를 사용합니다.
                // (주의: 백엔드 /api/GetEtcBanking 에서도 req.body.search 로 받도록 수정해야 합니다)
                search: search
            })
        };

        fetch("/api/GetEtcBanking", reqOption)
            .then((response) => response.json())
            .then(data => {
                setData(data);
                // ★ 데이터가 갱신(검색)될 때마다 무조건 1페이지로 돌려주는 UX 디테일 추가
                setCurrentPage(1);
            })
            .catch(err => console.error("EtcModels fetch error:", err)); // 에러 핸들링 추가
    }, [search]);

    return (
        <>
            {/* [구조 개선] 내용물(contentContainer)을 title div 바깥으로 분리했습니다. */}
            <div className={styles.title} onClick={() => setVisibleFirst(!visibleFirst)} style={{ cursor: 'pointer' }}>
                <span className={styles.outlinePdo}>
                    <img
                        className={visibleFirst ? styles.minusImg : styles.plusImg}
                        src={visibleFirst ? downTriangleIcon : sideTriangleIcon}
                        alt="toggle"
                    />
                </span>
                <span className={styles.pdoModels}>
                    {t('Pending Models')}
                </span>
                {/* num 객체 방어 코드 (num?.num) */}
                <span className={styles.PDOnumber}>{checkZero(num?.num)}</span>
            </div>

            {/* 내용을 감싸는 컨테이너는 title 영역과 형제(Sibling) 레벨로 두는 것이 마크업 구조상 올바릅니다. */}
            {visibleFirst && (
                <div className={styles.contentContainer}>
                    <div className={styles.cancerNamesContainer}>
                        {currentItems.map((data, index) => (
                            // returnFalse 래퍼 함수 제거 및 안전한 고유 key 부여
                            <CancerName
                                data={data}
                                returnFalse={returnFalse}
                                key={`etc-cancer-${index}`}
                            />
                        ))}
                    </div>
                    <div className={styles.paginationContainer}>
                        {pageNumbers.map(number => (
                            <span
                                key={number}
                                className={currentPage === number ? styles.activePage : styles.pageNumber}
                                onClick={() => handlePageClick(number)}
                            >
                                {number}
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
}

export default EtcModels;